import { useState, useCallback } from 'react';
import { adminPaymentsService, isApiError } from '@dopomogai/api-client';
import type { MonobankInvoiceStatus } from '@dopomogai/api-client';
import { AgentKitError } from '../../types';

export const useInvoiceActions = () => {
  // Separate loading states for different actions
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);
  const [isInvalidating, setIsInvalidating] = useState(false);
  const [error, setError] = useState<AgentKitError | null>(null);

  const checkStatus = useCallback(async (invoiceId: string) => {
    setIsCheckingStatus(true);
    setError(null);
    const res = await adminPaymentsService.getInvoiceStatus(invoiceId);

    if (isApiError(res)) {
      const err = new AgentKitError(`Failed to check status for invoice ${invoiceId}`, res);
      setError(err);
      setIsCheckingStatus(false);
      return null; // Return null on failure
    }
    
    setIsCheckingStatus(false);
    return res as MonobankInvoiceStatus; // Return the status data on success
  }, []);

  const invalidate = useCallback(async (invoiceId: string) => {
    setIsInvalidating(true);
    setError(null);
    const res = await adminPaymentsService.invalidateInvoice(invoiceId);

    if (isApiError(res)) {
      const err = new AgentKitError(`Failed to invalidate invoice ${invoiceId}`, res);
      setError(err);
      setIsInvalidating(false);
      return false; // Return false on failure
    }

    setIsInvalidating(false);
    return true; // Return true on success
  }, []);

  return {
    checkStatus,
    invalidate,
    isCheckingStatus,
    isInvalidating,
    error,
    clearError: () => setError(null),
  };
};